import { ChangeDetectionStrategy, Component, inject, resource, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { parseHttpError } from 'src/app/common/errors/app-error.model';
import { ImportSharedDataResponse } from './shared-data-import.model';
import { SharedDataImportService } from './shared-data-import.service';

/**
 * "Importer faste data": replaces Permission/ReportingCommandList/ReportingParameter/LogEvent/AutomationParameter and the global
 * ViewOpsaetning rows (KundeId = 0) with the previous environment's content. Shows row counts per table
 * first so the user confirms knowingly — the action cannot be undone.
 */
@Component({
    selector: 'app-shared-data-import-modal',
    templateUrl: './shared-data-import-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SharedDataImportModalComponent {
  readonly activeModal = inject(NgbActiveModal);
  private readonly service = inject(SharedDataImportService);

  readonly preview = resource({ loader: () => this.service.getPreview() });

  readonly importing = signal(false);
  readonly result = signal<ImportSharedDataResponse | null>(null);
  readonly error = signal<string | null>(null);

  /** "[dbo].[Permission]" → "dbo.Permission" — klammerne er SQL-støj i UI'et. */
  displayName(tableName: string): string {
    return tableName.replace(/[\[\]]/g, '');
  }

  async import(): Promise<void> {
    this.importing.set(true);
    this.error.set(null);
    try {
      this.result.set(await this.service.import());
    } catch (err) {
      // Vises inline i modalen (persistent fejl, brugeren skal se den her); den globale
      // ErrorService håndterer stadig 401/403/5xx-tierne.
      this.error.set(parseHttpError(err).message || 'Ukendt fejl');
    } finally {
      this.importing.set(false);
    }
  }
}
